import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { EstudoDetailComponent } from './estudo-detail.component';
import { EstudoPreliminarDetailComponent } from './estudo-preliminar-detail.component';
import { DadosPessoaisDetailComponent } from './dados-pessoais-detail.component';
import { AuthGuard } from 'ems-oauth2-client';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'estudo/:id', component: EstudoDetailComponent,  canActivate: [AuthGuard], data: {nome: '/estudo'}},
      { path: 'estudo', component: EstudoDetailComponent,  canActivate: [AuthGuard], data: {nome: '/estudo'}},
      { path: 'estudo_preliminar', component: EstudoPreliminarDetailComponent, canActivate:[AuthGuard], data: {nome: '/estudo_preliminar'}},
      { path: 'dados_pessoais', component: DadosPessoaisDetailComponent,  canActivate:[AuthGuard], data: {nome: '/dados_pessoais'} }

    ])
  ],
  exports: [RouterModule]
})
export class EstudoRoutingModule {

  /*ge{ path: 'grupo_familiar', component: GrupoFamiliarDetailComponent,  canActivate:[AuthGuard], data:{nome:'/grupo_familiar'} },
  { path: 'conclusao', component: ConclusaoDetailComponent,  canActivate:[AuthGuard], data:{nome:'/conclusao'} },*/

}
